module.exports = __webpack_public_path__ + "heart-blueprint-deep.62e8db70eabd22aa4c68.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-blueprint-deep.svg
// module id = ../../../../../src/assets/img/heart-blueprint-deep.svg
// module chunks = main